<template>
  <div class="toolbar">
    <toolbar-button class="toolbar-button-go-prev" @click="$emit('go-prev')">
      <i class="fa fa-arrow-circle-left"></i>
      Trước
    </toolbar-button>
    <toolbar-button @click="$emit('close')">
      <i class="fa fa-times-circle"></i>
    </toolbar-button>
    <toolbar-button class="toolbar-button-go-next" @click="$emit('go-next')">
      Sau
      <i class="fa fa-arrow-circle-right"></i>
    </toolbar-button>
  </div>
</template>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 50px;
}

.toolbar:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.toolbar-button-go-prev {
  justify-content: flex-start;
  min-width: 100px;
}

.toolbar-button-go-next {
  justify-content: flex-end;
  min-width: 100px;
}
</style>

<script>
import ToolbarButton from './ToolbarButton';

export default {
  components: {
    ToolbarButton,
  },
};
</script>
